import {
  GET_QUESTIONTYPES_SUCCESS,
  GET_QUESTIONTYPES_FAIL,
  GET_QUESTION_DETAIL_SUCCESS,
  GET_QUESTION_DETAIL_FAIL,
  ADD_QUESTION_RESPONSE_SUCCESS,
  ADD_QUESTION_RESPONSE_FAIL,
  GET_RESPONSE_OUTCOME_SUCCESS,
  GET_RESPONSE_OUTCOME_FAIL,
  GET_PROJECTS_SUCCESS,
  GET_PROJECTS_FAIL,
  GET_PROJECT_DETAIL_SUCCESS,
  GET_PROJECT_DETAIL_FAIL,
  GET_NNS_SUCCESS,
  GET_NNS_FAIL,
  ADD_PROJECT_FAIL,
  ADD_PROJECT_SUCCESS,
  UPDATE_PROJECT_SUCCESS,
  UPDATE_PROJECT_FAIL,
  GET_NNS_STRANDS_SUCCESS,
  GET_NNS_STRANDS_FAIL,
  GET_AWARD_PERIODS_SUCCESS,
  GET_AWARD_PERIODS_FAIL,
  CLEAR_QUESTIONNNAIRE_STATE,
} from "./actionTypes"

const INIT_STATE = {
  projects: [],
  project: {},
  nns: [],
  strands: [],
  periods: [],
  questiontypes: [],
  question: {},
  result: {},
  outcome: {},
  error: {},
  loading: true,
}

const Project = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PROJECTS_SUCCESS:
      return {
        ...state,
        projects: action.payload,
        loading: true,
      }
    case GET_PROJECTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_PROJECT_DETAIL_SUCCESS:
      return {
        ...state,
        project: action.payload,
        loading: true,
      }
    case GET_PROJECT_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_PROJECT_SUCCESS:
      return {
        ...state,
        projects: action.payload,
      }
    case ADD_PROJECT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_PROJECT_SUCCESS:
      return {
        ...state,
        projects: state.projects.map(p =>
          p.LearningProjectID.toString() ===
          action.payload.LearningProjectID.toString()
            ? { p, ...action.payload }
            : p
        ),
      }
    case UPDATE_PROJECT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_NNS_SUCCESS:
      return {
        ...state,
        nns: action.payload,
        loading: true,
      }
    case GET_NNS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_QUESTIONTYPES_SUCCESS:
      return {
        ...state,
        questiontypes: action.payload,
        loading: true,
      }
    case GET_QUESTIONTYPES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_QUESTION_DETAIL_SUCCESS:
      return {
        ...state,
        question: action.payload,
        loading: true,
      }
    case GET_QUESTION_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_QUESTION_RESPONSE_SUCCESS:
      return {
        ...state,
        result: action.payload,
      }
    case ADD_QUESTION_RESPONSE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_RESPONSE_OUTCOME_SUCCESS:
      return {
        ...state,
        outcome: action.payload,
        loading: true,
      }
    case GET_RESPONSE_OUTCOME_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_NNS_STRANDS_SUCCESS:
      return {
        ...state,
        strands: action.payload,
        loading: true,
      }
    case GET_NNS_STRANDS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_AWARD_PERIODS_SUCCESS:
      return {
        ...state,
        periods: action.payload,
        loading: true,
      }
    case GET_AWARD_PERIODS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case CLEAR_QUESTIONNNAIRE_STATE:
      return {
        projects: [],
        project: {},
        nns: [],
        questiontypes: [],
        question: {},
        result: {},
        outcome: {},
        strands: [],
        periods: [],
      }
    default:
      return state
  }
}

export default Project
